<template>
  <div class="ac3">
    <!-- 标题 -->
    <div class="ac3-title">
      <h2>热门话题</h2>
    </div>
    <!-- 循环项 -->
    <div class="ac3-item" v-for="(item, index) in data" :key="index" @click="gopay(item.methods, item.id)">
      <!-- 图片 -->
      <div class="item-img">
        <img :src="item.img" alt="" />
      </div>
      <!-- 标题 -->
      <p>{{ item.title }}</p>
    </div>
    <modal title="请支付阅读" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <img style="display: flex; justify-content: center; width:200px; margin: 0 auto;" src="/imgs/pay.png" />
        <h2>微信支付：2元/篇</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import Modal from "./../components/Modal";
export default {
  name: "ac3",
  components: {
    Modal,
  },
  data() {
    return {
      data: [],
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
      showModal: false,
    };
  },
  mounted() {
    this.init();
    document.title = "北京学灯教育科技有限公司";
  },
  methods: {
    init() {
      this.axios.get("/mock/a1.json").then((res) => {
        const data = res.data;
        // 两条数据
        this.data = data.splice(3, 3);
        // console.log(this.data);
      });
    },
    // 跳转 逻辑 封装
    goDays(methods, id) {
      this[methods](id);
    },
    // 收费逻辑
    gopay() {
      this.showModal = true;
      // if (this.state == 0) {
      //   this.$router.push("/pay");
      //   // this.showModal = true;
      // }
      // // 未登录
      // if (this.state !== 0) {
      //   alert("请登录付费2元后可浏览！！！~");
      //   this.$router.push({ path: "/login", query: { k: 1 } });
      //   return;
      // }
    },
    // 跳转详情页
    goDetails(id) {
      this.$router.push({
        path: "/sound/:" + id,
        query: { type: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.ac3 {
  width: 100%;
  margin-bottom: 30px;

  //   height: 600px;
  //   background-color: #888;
  // 标题
  .ac3-title {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #ccc;
    // padding-left: 30px;
    box-sizing: border-box;

    h2 {
      font-size: 16px;
      width: 80px;
      height: 100%;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid $colorZ;
    }
  }

  //  循环项
  .ac3-item {
    width: 100%;
    height: 300px;
    // background-color: pink;
    cursor: pointer;
    background-color: #fff;
    margin: 20px auto;

    // 图片
    .item-img {
      width: 100%;
      height: 250px;
      border: 1px solid #fff;

      img {
        width: 100%;
        height: 100%;
      }
    }

    // 标题
    P {
      width: 100%;
      font-size: 12px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;
      padding: 0 10px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: all 0.3s;
      cursor: pointer;

      &:hover {
        color: $colorZ;
      }
    }
  }
}
</style>
